<template>
  <div>
    <PCNavbar selectIndex="1-1" style="background: #ececec;"/>
    <MobileNavBar :currentActive="1" />
    <Contest/>
    <!--  页脚  -->
    <Footer/>

  </div>
</template>

<script>
import PCNavbar from '@/views/home/navbar/indexDetail.vue'
import MobileNavBar from '@/views/home/navbar/MobileNavBar.vue'
import Footer from '@/views/home/callme/footerIndex.vue'
import Contest from "@/views/business/contest/list.vue";
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    Contest,
    Footer
  },
}
</script>

<style>
</style>